<div class="app-page" style="margin-left: 10px;">
  @if (this._flow.length==0) {
    <div style="display: flex; justify-content: center; margin-top: 30px;" >
      <div style="font-family: Roboto;">No assessments in the last month</div>
    </div>
  }
  <div style="display: flex;flex-direction: row;flex-wrap: wrap;">


    @for (evt of _flow; track evt) {
      @if (evt.EventType=='SELFASSESSMENT') {
        <app-load-player-status [event]="evt">
        </app-load-player-status>
      }
      @if (evt.EventType=='GAMERANK') {
        <app-load-game-assessment [event]="evt">
        </app-load-game-assessment>
      }
    }

  </div>
</div>

